export default __webpack_public_path__ + "static/media/a023-startup5-short.dcd0496c.png";